import { BaseTabFormData } from '@/modules/common/components/templates/feature-details/types/types';
import { CreateAttributeValueRequest } from '@/modules/common/types/dto/request/custom-attribute-request';
import { Manager } from '@/modules/projects/types/project';
import { Department } from '@/modules/settings/types/department';
import { Role } from '@/modules/settings/types/role';
import { Seniority } from '@/modules/settings/types/seniority';
import { TeamMemberIntegration } from '@/modules/team';

import { MembershipType } from './membership-type';
import { InternalRateType, MemberStatus, TeamMemberType } from './team-member';

export * from './dto/find-short-team-members.request';
export * from './dto/request/create-team-member-request';
export * from './dto/request/get-team-member-rates-on-project-request';
export * from './dto/request/update-team-member-billing-request';
export * from './dto/request/update-team-member-capacity-request';
export * from './dto/request/update-team-member-info-request';
export * from './dto/request/update-team-member-request';
export * from './dto/response/team-member-billing-response';
export * from './dto/response/team-member-capacity-response';
export * from './dto/response/team-member-full-response';
export * from './dto/response/team-member-info-response';
export * from './dto/response/team-member-rates-on-project-response';
export * from './dto/response/user-rate-option-response';
export * from './dto/team-member-short.dto';
export * from './membership-type';
export * from './team-member';
export * from './team-member-changes';
export * from './team-member-integration';

export enum TeamMemberTab {
  Info = 'info',
  Capacity = 'capacity',
  Billing = 'billing',
  Integrations = 'integrations',
  Changes = 'changes',
  TimeOff = 'time-off',
}

export interface TeamMemberCapacityFormData {
  capacityPerDay: number;
  billableCapacity: number;
  corporateFunctionCapacity: number;
  isOnDemandAvailability: boolean;
}

export interface TeamMemberBillingFormData {
  internalRateCurrency?: string;
  internalRateType?: InternalRateType;
  internalRate?: number;
  externalHourlyRate?: number;
}

export interface TeamMemberIntegrationsFormData {
  integrations?: TeamMemberIntegration[];
}

export interface TeamMemberFormData extends BaseTabFormData {
  // Info fields
  name: string;
  email?: string;
  status: MemberStatus;
  type: TeamMemberType;
  // Department/role/seniority can be objects (from API), numbers, or string IDs (from form)
  department?: Department | number | string;
  seniority?: Seniority | number | string;
  role?: Role | number | string;
  managerId?: string;
  manager?: Manager;
  tags?: string[];
  membershipType?: MembershipType | null;
  avatarLink?: string | File;
  dateOfJoin?: Date;

  // Location fields
  country: string;
  city: string;

  // Contact information
  phoneNumber?: string;

  // Role and management
  isManager: boolean;
  about?: string;

  // Capacity fields
  isOnDemandAvailability?: boolean;
  capacityPerDay?: number;
  billableCapacity?: number;
  corporateFunctionCapacity?: number;

  // Billing fields
  internalRateCurrency?: string;
  internalRateType?: InternalRateType;
  internalRate?: number;
  externalHourlyRate?: number;

  // Integration fields
  integrations?: TeamMemberIntegration[];

  // Custom attribute values (sent through the info endpoint, non-versioned)
  customAttributesValues?: CreateAttributeValueRequest[];
}

export interface InternalRateTypeOption {
  value: InternalRateType;
  label: string;
}
